import { useQuery } from "@tanstack/react-query";
import { fetchSubscriptions } from "../api/subscriptionsApi";

const QUERY_KEY = ["subscriptions"];

export const useSubscriptionsQuery = () => {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: fetchSubscriptions,
  });
};
